// Semantic color aliases over the project's Mantine CSS variables.
// Components in the design system should reference these instead of raw
// `theme.colors["R500"][0]` or hardcoded hex values.

export const colors = {
  brand: {
    primary: "var(--mantine-color-R500-0)",
    primaryHover: "var(--mantine-color-R600-0)",
    dark: "var(--mantine-color-P900-0)",
  },
  danger: {
    default: "var(--mantine-color-V500-0)",
    hover: "var(--sa-danger-fill-hover)",
    light: "var(--mantine-color-V300-0)",
  },
  success: {
    default: "var(--mantine-color-A500-0)",
    light: "var(--mantine-color-A300-0)",
  },
  text: {
    default: "var(--mantine-color-plain_text-0)",
    accent: "var(--mantine-color-contrast_text-0)",
    accentDarker: "var(--mantine-color-contrast_text_darker-0)",
    onColorBg: "var(--mantine-color-text_with_colorful_bg-0)",
    listItem: "var(--mantine-color-list_item_text-0)",
    placeholder: "var(--mantine-color-L800-0)",
    disabled: "var(--mantine-color-disabled_input_text-0)",
  },
  background: {
    base: "var(--mantine-color-background_3-0)",
    surface: "var(--mantine-color-background_1-0)",
    secondary: "var(--mantine-color-background_2-0)",
    subtle: "var(--mantine-color-background_4-0)",
  },
  disabled: {
    element: "var(--mantine-color-disabled_element-0)",
    inputBg: "var(--mantine-color-disabled_input_background-0)",
    inputText: "var(--mantine-color-disabled_input_text-0)",
  },
  white: "var(--mantine-color-L100-0)",
  // P900 — used intentionally in dark gradient backgrounds
  darkBrand: "#140248",
} as const;

/** Gradient used on auth/onboarding dark backgrounds. */
export const DARK_GRADIENT =
  "linear-gradient(117deg, #140248 0%, #140248 94.25%)";

/** Light lavender background used on the auth panel (right side of AuthLayout).
 *  Not yet in the Mantine token system — centralized here until R100 is added. */
export const AUTH_PANEL_LIGHT_BG = "#F6F2FF";
